import EncryptedStorage from '$tablet-app/src/app/utils/encryptedStorage';

/** Checks if app is locked and returns the user id of who locked it */
export const getAppIsLocked = async (): Promise<string | null> => {
  return await EncryptedStorage.getItem(`app-locked`);
};

interface Params {
  /** The list of valid user ids */
  profile_ids: string[];
}

export const getAppLockedProfileID = async ({
  profile_ids,
}: Params): Promise<string | undefined> => {
  const profile_id = await getAppIsLocked();

  // Not locked, return
  if (!profile_id) return;

  /** Check if profile used to lock the app is actually part of the current habitat */
  if (!profile_ids.includes(profile_id)) {
    return;
  }

  return profile_id;
};
